import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';

const LogoutButton: React.FC = () => {
    const { instance } = useMsal();

    const handleLogout = () => {
        localStorage.removeItem('activeClientId');
        instance.logoutRedirect();
    };

    return (
        <Button color="secondary" variant="outlined" onClick={handleLogout}>
            Logout
        </Button>
    );
};

export default LogoutButton;
